import styled from 'styled-components';

import { Container } from '../../styles/global';

const NoMatchContainer = styled(Container)`
  && {
    max-width: none;
    justify-content: center;

    background: #FFFFFF;

    border-top: 5px solid ${(props) => props.theme.cores.primaria};
  }
`;

export default NoMatchContainer;
